import image0 from '../assets/news/event-01.png';
import image1 from '../assets/news/event-02.jpg';
import image2 from '../assets/news/event-03.png';
import image3 from '../assets/news/event-04.jpg';
import image4 from '../assets/news/event-05.jpg';
import image5 from '../assets/news/event-06.jpg';
import image6 from '../assets/news/event-07.jpg';
import image7 from '../assets/news/event-08.jpg';
import image8 from '../assets/news/event-09.jpg';
import image9 from '../assets/news/event-10.jpg';
import image10 from '../assets/news/event-11.jpg';
import image11 from '../assets/news/event-12.jpg';
import image12 from '../assets/news/event-13.jpg';
import image13 from '../assets/news/event-14.png';

const newsEvents = [
  {
    "id": "event-01",
    "date": "2026年6月1日",
    "title": "第一届网易游戏雷火×“未名造梦”游戏开发大赛收官",
    "body": "2026年6月1日，第一届网易游戏雷火×“未名造梦”游戏开发大赛在北京大学创新创业中心阶梯教室举行线下答辩、试玩与颁奖。赛事由北京大学独立游戏开发者联盟与网易游戏雷火共同组织，白鲸游研爱好者小组协助开展，吸引数十支学生团队参与。自4月启动报名以来，参赛者经历创意构思、作品开发、线上指导与提交评审，将游戏想法转化为可以体验的作品。决赛现场，团队展示设计思路和开发成果，曹琪、韩宇华及行业评委围绕创意、可玩性、完成度与视听表现进行评价，参与者也通过试玩投票表达意见。最终，《视窗防线》获得金奖，《爱托邦》获得银奖，《Uumi》获得铜奖。活动把作品陈述、实际游玩和专业反馈结合起来，为学生开发者提供检验创意、交流制作经验的机会，也呈现了校园游戏创作从兴趣探索走向完整作品的实践过程。",
    "image": image0
  },
  {
    "id": "event-02",
    "date": "2026年4月11—12日",
    "title": "第三届博雅国际电子游戏学术年会",
    "body": "2026年4月11日至12日，第三届博雅国际电子游戏学术年会举行，以“演绎／延异规则——创造性思考电子游戏中的力”为主题，由北京大学艺术学院、中国传媒大学动画与数字艺术学院、游戏与艺术创研中心共同主办。会议围绕游戏规则、玩家行动与创造性实践展开讨论，并在开幕式发布第二辑《游戏文化经典译丛》的五部新书。米格尔·西卡特、奥利·塔皮奥·莱诺等学者从具体游戏形式与游玩实践出发，探讨规则与自由、表演和行动之间的关系。46篇论文分入“赛博文本”“游戏改变世界”“帝国的游戏”“游戏感”四个板块，呈现不同学科的研究路径。会议还设置游戏教育、人工智能、电子竞技与物质性等相关交流环节，并与清华大学游戏哲学论坛形成对话。通过主题演讲、论文报告和圆桌讨论，年会将理论分析与技术、产业及玩家经验联系起来，继续拓展电子游戏研究的议题与方法。",
    "image": image1
  },
  {
    "id": "event-03",
    "date": "2025年12月25日",
    "title": "《王朝周期率：春秋战国》主创交流",
    "body": "2025年12月，中心举办《王朝周期率：春秋战国》主创交流活动。正式推文预告的时间为12月25日14时至17时30分，地点为北京大学计算艺术实验室，邀请湖南速子文化的文案主创、主编剧与主美参与，由王洪喆主持交流。活动以历史策略游戏的创作实践为切入点，围绕内容组织、系统设计与开发流程展开，关注历史知识如何转化为玩家可以理解、选择和行动的游戏机制。作品以春秋战国为背景，将角色扮演、家族关系与外交等内容纳入策略体验，为讨论历史叙事与系统规则之间的关系提供案例。根据活动预告，交流还安排作品试玩及相关互动，使参与者能够结合实际操作理解团队的设计思路。主创团队此前参与历史策略游戏模组开发，这一背景也为观察从模组实践走向独立作品的制作过程提供线索。活动将游戏研究与开发经验相连接，呈现历史题材创作中的文化表达和媒介问题。",
    "image": image2,
    "note": "日期依正式活动预告；以下为活动介绍。"
  },
  {
    "id": "event-04",
    "date": "2025年12月6日",
    "title": "年度游戏线下试玩活动",
    "body": "2025年12月6日13时至19时，游戏与艺术创研中心在计算艺术实验室开展年度游戏线下试玩活动，白鲸学生小组参与筹备与现场支持。活动汇集百余名来自不同学科的参与者，设置八套涵盖PS5、电脑与Switch 2的设备，提供十余款TGA提名作品及年度热门游戏的体验机会。《死亡搁浅2》《空洞骑士：丝之歌》《光与影：33号远征》《天国：拯救2》等不同类型的作品进入同一试玩空间，让参与者能够对照观察叙事、视觉风格与操作机制。筹备团队提前选择适合现场体验的游戏片段，并协助玩家熟悉操作，降低接触新作品的门槛。在持续六小时的活动中，同学们轮流试玩、观看和交流，将个人感受转化为关于游戏设计与审美表达的讨论。活动回顾还汇集参与者的推荐与评价，记录不同偏好之间的碰撞，为中心日常的游戏研究补充直接的游玩经验与共同讨论的材料。",
    "image": image3
  },
  {
    "id": "event-05",
    "date": "2025年12月1日（发布）",
    "title": "怀旧游戏博物馆新版介绍",
    "body": "2025年12月1日，“未名游戏”公众号介绍怀旧游戏博物馆的新版功能与建设进展。项目始于2023年，经过持续整理与改版，将数百款经典游戏汇集到网页中，尝试以便于访问和体验的方式保存游戏文化记忆。用户可以通过浏览器查找与游玩不同年代的作品，内容涵盖《魂斗罗》《拳皇》《红色警戒》《黄金矿工》等熟悉的游戏，也提供面向手机与电脑的访问方式。新版围绕检索、浏览和游戏推荐改进使用体验，并以“游戏流”等入口帮助用户发现作品，部分游戏支持多人参与。推文介绍，项目由中心青年研究员俞果、档案主管阎峻与档案管理员皮知玠等成员共同推进，当时采用无广告、无付费内容的开放形式。作为一项持续建设的数字档案实践，博物馆把经典作品的整理与实际游玩连接起来，使游戏史材料不仅能够被查阅，也能够通过操作被重新理解，为研究、教学和个人回忆提供接触早期游戏的入口。",
    "image": image4,
    "link": "https://rgm.games/",
    "linkLabel": "访问怀旧游戏博物馆"
  },
  {
    "id": "event-06",
    "date": "2025年7月27日",
    "title": "《影之刃零》线下试玩与开发交流",
    "body": "2025年7月27日，游戏与艺术创研中心的研究者前往北京首钢园，参加S-Party 2025中的《影之刃零》线下试玩，并与制作人梁其伟及开发团队交流。活动将具体操作体验与研究讨论结合起来，参与者通过试玩关卡和首领战，观察作品如何以动作系统、武器设计与视听反馈呈现武侠世界。围绕“七星剑阵”等体验内容，研究者从战斗节奏、难度安排、身体感受和空间组织等方面分享看法，也讨论电影语言、武术审美与游戏世界构建之间的联系。交流中，中心向开发团队赠送《游戏文化经典译丛》，将游戏研究的文献积累带入创作对话。随后发布的试玩反馈保留了不同研究者的个人观察，呈现同一作品在操作、叙事与文化表达层面的多种理解。此次活动为学术研究者直接接触开发中的作品提供机会，也让关于国产游戏的讨论建立在具体体验与制作交流之上。",
    "image": image5
  },
  {
    "id": "event-07",
    "date": "2025年4月19日起",
    "title": "第二届博雅国际电子游戏学术年会暨游戏文化经典译丛发布",
    "body": "2025年4月19日，第二届博雅国际电子游戏学术年会在北京大学燕京学堂报告厅开幕，以“原型缝合／缝隙：敞开电子游戏的类型研究”为主题，汇聚游戏研究者、青年学者与创作实践者。会议收到来自8个国家和地区、94所高校及企业等机构的179篇有效投稿，讨论游戏类型如何在技术、玩家行为与文化语境中形成和变化。艾斯本·阿尔萨斯、马克·沃尔夫等学者参与主题演讲，分论坛围绕游戏机制、身体体验、媒介技术与类型边界展开交流。开幕式同期举行《游戏文化经典译丛》发布，李洋、丁亚平与张宇清共同介绍这一出版成果，将海外游戏研究经典的译介与国内学术讨论相连接。会议还设置圆桌讨论、早期经典动作游戏试玩等环节，让论文交流与实际游玩相互参照。围绕类型研究这一共同问题，年会为不同学科背景的参与者提供了交流研究方法、分享游戏经验的机会。",
    "image": image6
  },
  {
    "id": "event-08",
    "date": "2025年春季学期",
    "title": "“游戏与哲学”研讨课程",
    "body": "2025年春季学期，北京大学游戏与艺术创研中心与清华大学哲学系、日新书院开展“游戏与哲学”研讨课程，由李洋、夏莹等组织教学。课程大纲列出的授课时间为2月17日至6月6日，共十六周，每周三学时，将教师讲授与学生报告、讨论相结合。课程以游戏及其哲学内涵为核心，关注人为什么创造并遵循规则，以及游玩如何涉及价值、身份、道德规范与审美判断。教学把哲学经典阅读、电子游戏经验与具体案例分析连接起来，讨论游戏的基本概念、游玩的价值及其在生活中的作用，并训练学生对机制、叙事和互动性进行批判性思考。课前材料包括指定文献与相关影像，课程也鼓励结合条件体验参考游戏，使抽象问题能够获得具体的分析对象。通过多位教师的不同研究视角，课程尝试在哲学训练与游戏研究之间建立联系，为跨校教学和以游戏为对象的人文讨论提供共同的学习框架。",
    "image": image7,
    "note": "课程安排依据发布的教学大纲。"
  },
  {
    "id": "event-09",
    "date": "2024年11月26日",
    "title": "许煜讲座：艺术与媒介",
    "body": "2024年11月26日下午，许煜在北京大学艺术学院带来“艺术与媒介”讲座，由李洋主持，程乐松参与对谈。讲座围绕艺术作品与其媒介条件之间的关系展开，讨论技术变化如何影响创作、感知和作品的延续。许煜从艺术对媒介的依赖出发，分析数字技术更新所带来的保存与过时问题，并进一步追问艺术能否在既定的媒介条件中形成抵抗和新的可能。讨论涉及观念艺术、物质性与递归等问题，将具体艺术实践同技术哲学的思考联系起来，也关注艺术经验中不能被计算与理性程序完全穷尽的部分。讲座并未把媒介仅仅视为承载内容的工具，而是将其置于作品生成、观看方式和思想表达的关系中加以考察。在对谈中，相关问题被进一步引向艺术与技术的当代处境。此次交流为理解数字艺术的技术条件及其开放性提供了理论线索，也为游戏与艺术研究中的媒介问题补充了可供讨论的哲学视角。",
    "image": image8
  },
  {
    "id": "event-10",
    "date": "2024年11月10日",
    "title": "解读游戏与意义",
    "body": "2024年11月10日晚，艾斯本·阿尔萨斯在北京大学全球大学生创新创业中心大讲堂带来“解读游戏与意义”讲座。活动由李洋主持，车致新、芮玛窦参与对谈，围绕游戏如何产生意义、游戏研究如何建立分析框架展开讨论。阿尔萨斯从游戏本体论出发，指出游戏既涉及文本与符号，也包含机械系统、物质条件及玩家的操作与体验，理解游戏需要关注这些层面之间的联系。他进一步从物理、结构、交流与心理等维度分析游戏现象，并讨论游戏机制与表现形式如何共同参与意义生成。讲座还涉及程序修辞、规则与虚构、游戏批评和玩家体验等问题，反思将文学等领域的既有方法直接用于游戏分析时可能遇到的困难。在对谈环节，嘉宾围绕跨学科研究及游戏的文化意义继续交流，将“如何解释游戏”的理论问题与具体的游玩经验相联系，为从人文与艺术视角开展游戏研究提供了讨论线索。",
    "image": image9
  },
  {
    "id": "event-11",
    "date": "2024年10月26日",
    "title": "从笔墨到像素 四大名著与电子游戏",
    "body": "2024年10月26日，“从笔墨到像素：四大名著与电子游戏”北大人文论坛在北京大学对外交流中心举行。论坛由北京大学艺术学院、中国高等院校影视学会游戏与艺术创研中心、北京大学人文学部主办，以经典文学的电子游戏改编为切入点，讨论传统故事如何在数字媒介中被重新讲述，以及玩家如何通过行动参与经典的当代表达。与会研究者结合《黑神话：悟空》及三国题材游戏等案例，从叙事、游戏机制、地图设计和文化传播等角度展开分析。讨论既关注人物与情节的转换，也涉及历史文化内容的取舍、玩家体验与价值表达之间的关系，以及经典改编在全球文化语境下面临的问题。论坛将文学研究与游戏研究置于共同的讨论空间，尝试理解电子游戏改编如何超出故事移植，形成自身的表达方式。围绕具体作品的交流，也为进一步书写经典文学的游戏改编史、开展跨学科研究积累了问题与材料。",
    "image": image10
  },
  {
    "id": "event-12",
    "date": "2024年4月20—21日",
    "title": "首届博雅国际电子游戏学术年会暨创研中心揭牌",
    "body": "2024年4月20日至21日，首届博雅国际电子游戏学术年会在北京大学举行，主题为“视／世界涌现：启动电子游戏研究的多重面向”。20日上午，年会开幕式暨游戏与艺术创研中心揭牌仪式在燕京学堂报告厅举行，董丽慧主持，彭锋、丁亚平等嘉宾出席。李洋以点击游戏的形式完成创意揭牌，并介绍中心为游戏研究者搭建交流平台的初衷。年会收到217份投稿，吸引境内外高校的研究者参与。米切尔、彼得·奈尔森、朱青生、冯梦波、耶斯帕·尤尔、马修·佩恩等学者与艺术家围绕游戏空间、风景艺术、创作实践及媒介机制等议题展开分享，呈现电子游戏研究的多重视角。会议同时安排特别放映与圆桌讨论，并通过游戏风格的合影、会议手册和纪念物料，将玩家文化融入学术交流。年会与中心揭牌共同开启了一个面向游戏历史、理论与批评的持续交流平台。",
    "image": image11
  },
  {
    "id": "event-13",
    "date": "2022年12月18日",
    "title": "持续施／失控 电子游戏历史与理论工作坊",
    "body": "2022年12月18日，“持续施／失控：电子游戏历史与理论工作坊”以线上形式举行，集中呈现北京大学艺术学院“艺术文献翻译与研究”课程的结课报告。工作坊由李洋主持，海报列有蓝江、夏莹、姜宇辉、车飞等评议嘉宾，以及王洪喆、车致新、董树宝、李典峰等特约主持，围绕电子游戏的历史与理论展开跨学科交流。报告议题涵盖游戏类型、主机发展史、电子竞技，以及游戏与哲学、伦理、教育等领域的联系，将海外研究文献的阅读与翻译同具体问题的分析结合起来。参与者从不同研究方向进入电子游戏，讨论其作为技术、文化与艺术现象的复杂性，也关注游戏机制与社会经验之间的关联。作为中心成立前的学术活动，工作坊将课程学习、文献积累和公开讨论连接起来，为后续开展游戏历史与理论研究积累了资料，并为持续组织青年研究者交流提供了基础。",
    "image": image12,
    "note": "中心前身学术活动"
  },
  {
    "id": "event-14",
    "date": "2021年3月20—21日",
    "title": "游戏咏／永生工作坊",
    "body": "2021年3月20日至21日，“游戏咏／永生”游戏研究工作坊在UCCA尤伦斯当代艺术中心举行，由北京大学艺术学院李洋召集，来自北京大学、北京外国语大学、中国传媒大学、南京大学、华东师范大学、腾讯研究院等机构的学者及艺术家参与。活动尝试以相对集中的讨论，将青年学者对游戏的观察与反思连接起来，并把游戏与思想之间的问题放在共同的交流场域中。首日发言涉及游戏中的情感关系、中国电子游戏发展、游戏的文学表达，以及游戏机制与社会文化系统的联系；艺术家与开发者也结合个人创作经验参与讨论。晚间圆桌进一步回顾游戏进入艺术领域的历史，讨论游戏成为艺术的可能性，并与现场及直播观众互动。第二日继续围绕游戏时代的经验与思想展开交流。作为中心成立前的重要学术活动，工作坊将研究者、创作者与玩家的视角汇集在一起，为此后的游戏研究讨论积累了共同的问题意识。",
    "image": image13,
    "note": "中心前身学术活动"
  }
];

export default newsEvents;
